export default __webpack_public_path__ + "static/blogThumbnail(8)-bfb3cea336a4646349aa771ae79105c2.png";